import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

/**
 * Use it instead of calling `localStorage` directly.
 */
@Injectable({ providedIn: "root" })
export class StorageService {
  private readonly storage: Storage | null;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.storage = isPlatformBrowser(platformId) ? localStorage : null;
  }

  getItem(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  setItem(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  removeItem(key: string): void {
    this.storage?.removeItem(key);
  }
}
